module.exports = __webpack_public_path__ + "img/zt_pic5.bfc0ccbb.jpg";